<template>
  <section class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>

      <div class="row">
        <div class="col-xs-12 col-sm-12 content">
          <data-table
            ref="escalas"
            title="lista de dados"
            :has-auth="false"
            :api-mode="false"
            :dados="lista.escalas"
            :show-empty="true"
            :fields="datatable.columns"
            :carregando="lista.carregando"
          >
            <template slot="actions">
              <router-link class="btn btn-default" to="add">
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
            </template>

            <template slot="columncustom" slot-scope="props">
              <section>
                <article
                  v-for="({ entrada, saida, dias }, index) in props.rowData.periodos"
                  :key="index"
                >
                  <label>
                    <div v-if="entrada !== ''">
                      {{ entrada }}
                    </div>
                    <div v-else>
                      <font-awesome-icon :icon="'arrow-alt-circle-right'"></font-awesome-icon>
                    </div>

                    <div v-if="entrada !== '' && saida !== ''">-</div>

                    <div v-if="saida !== ''">
                      {{ saida }}
                    </div>
                    <div v-else>
                      <font-awesome-icon :icon="'arrow-alt-circle-right'"></font-awesome-icon>
                    </div>
                  </label>

                  <span v-for="(dia, index) in dias" :key="index">
                    {{ dia }}
                  </span>
                </article>
              </section>
            </template>

            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DataTable from '@/components/common/NoApiTable'
import { request } from '@/request'

export default {
  inject: ["showConfirm"],
  data() {
    return {
      title: 'Escalas',
      type: 'ESCALA',
      datatable: {
        columnID: 'id',
        columns: [
          {
            name: 'uor_sigla',
            title: 'Unidade',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'referencia',
            title: 'Referência',
            dataClass: 'align-middle',
            callback: value => {
              const year = value.substr(0, 4)
              const month = value.substr(-2) - 1
              const date = new Date(year, month, 1)
              return Intl.DateTimeFormat('pt-BR', {
                month: 'short',
                year: 'numeric'
              })
                .format(date)
                .toUpperCase()
                .replace('. DE ', '/')
            },
            filterable: true
          },
          {
            name: 'colaborador_nome',
            title: 'Colaborador',
            dataClass: 'align-middle text-capitalize',
            filterable: true
          },
          {
            name: 'colaborador_cargo',
            title: 'Cargo',
            dataClass: 'align-middle text-capitalize',
            filterable: true
          },
          {
            name: 'plantao_total',
            title: 'Qtde Plantões',
            dataClass: 'text-center'
          },
          {
            name: '__slot:column',
            title: 'Horários | Dias'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-1',
            dataClass: 'text-center'
          }
        ],
        filters: {
          unidade: '',
          funcionario: ''
        }
      },
      lista: {
        escalas: [],
        carregando: false
      }
    }
  },
  components: {
    DataTable
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadEscala()
  },
  methods: {
    loadEscala() {
      this.lista.carregando = true
      request.get('escala/list')
      .then(response =>  this.lista.escalas = response.data)
      .catch(error => console.log(error))
      .then(() => this.lista.carregando = false);
    },
    entradaIsEmpty(periodo) {
      return this.getEmpty(periodo.split('-')) === 'entrada'
    },
    saidaIsEmpty(periodo) {
      return this.getEmpty(periodo.split('-')) === 'saida'
    },
    getEmpty([entrada, saida]) {
      if (entrada === '') return 'entrada'
      if (saida === '') return 'saida'

      return false
    },
    excluir({ id }) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.post('escala/removerFuncionario', { id })
          .then(() => this.removeEscala(id))
          .catch(error => {
            console.log(error)
            this.$toastr.e('Houve uma falha ao tentar remover o funcionário da escala, Tente novamente daqui alguns minutos!')
          })
        }
      }
      this.showConfirm('Deseja realmente remover este item?', config)
    },
    removeEscala(ID) {
      this.lista.escalas = this.lista.escalas.filter(({ id }) => id !== ID)
    }
  }
}
</script>

<style scoped="">
section div a {
  margin-bottom: 8px;
}

section {
  display: flex;
  flex-direction: column;
}

article {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

article:not(:first-child) {
  border-top: solid 1px #ccc;
}

article label {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  border: 1px solid transparent;
  padding: 0px 5px;
  font-size: 11px;
  font-weight: 600;
  margin: 0px;
  white-space: nowrap;
  width: 78px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

article label div:first-child svg {
  margin-left: 10px;
}

article label div:last-child svg {
  margin-right: 10px;
}

article span {
  background-color: white;
  border-color: #d6e9c6;
  border: 1px solid transparent;
  padding: 0px 0px 0px 5px;
  font-size: 11px;
  font-weight: 500;
}

.text-capitalize {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/escalas/index.vue